import script from "./WapStaffPortalView.vue?vue&type=script&lang=ts&setup=true"
export * from "./WapStaffPortalView.vue?vue&type=script&lang=ts&setup=true"

import "./WapStaffPortalView.vue?vue&type=style&index=0&id=0e7805fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e7805fe"]])

export default __exports__